import { FieldValue } from '../../../../datasets/instances/store/types';
import { MLData } from '../../../../datasets/store/mlTypes';
import { SingleDatasetFieldType } from '../../../../datasets/store/types';
import { AnalysisView } from '../../../../documents/store/types';
import { ColumnSort, SortOrder, TableFilters } from '../../../../shared/table/types';

export enum FewShotDocumentActionTypes {
    SET_SELECTED_FEW_SHOT_AGREEMENT_TYPE = 'SET_SELECTED_FEW_SHOT_AGREEMENT_TYPE',
    FETCH_AGREEMENT_TYPE_FEW_SHOT_DOCUMENTS_STARTED = 'FETCH_AGREEMENT_TYPE_FEW_SHOT_DOCUMENTS_STARTED',
    FETCH_AGREEMENT_TYPE_FEW_SHOT_DOCUMENTS_SUCCESSFUL = 'FETCH_AGREEMENT_TYPE_FEW_SHOT_DOCUMENTS_SUCCESSFUL',
    FETCH_AGREEMENT_TYPE_FEW_SHOT_DOCUMENTS_FAILED = 'FETCH_AGREEMENT_TYPE_FEW_SHOT_DOCUMENTS_FAILED',
    SET_FEW_SHOT_DOCUMENTS_TABLE_FILTERS = 'SET_FEW_SHOT_DOCUMENTS_TABLE_FILTERS',
    CLEAR_FEW_SHOT_DOCUMENTS_TABLE_FILTERS = 'CLEAR_FEW_SHOT_DOCUMENTS_TABLE_FILTERS',
    SET_FEW_SHOT_DOCUMENTS_TABLE_COLUMN_SORT = 'SET_FEW_SHOT_DOCUMENTS_TABLE_COLUMN_SORT',
    SET_FEW_SHOT_DOCUMENTS_PAGE_SIZE = 'SET_FEW_SHOT_DOCUMENTS_PAGE_SIZE',
    FEW_SHOT_DOCUMENTS_PAGINATION_NEXT = 'FEW_SHOT_DOCUMENTS_PAGINATION_NEXT',
    FEW_SHOT_DOCUMENTS_PAGINATION_PREVIOUS = 'FEW_SHOT_DOCUMENTS_PAGINATION_PREVIOUS',
    TOGGLE_UPLOAD_FEW_SHOT_DOCUMENT_MODAL_OPEN = 'TOGGLE_UPLOAD_FEW_SHOT_DOCUMENT_MODAL_OPEN',
    UPLOAD_FEW_SHOT_DOCUMENTS_STARTED = 'UPLOAD_FEW_SHOT_DOCUMENTS_STARTED',
    UPLOAD_FEW_SHOT_DOCUMENTS_SUCCESSFUL = 'UPLOAD_FEW_SHOT_DOCUMENTS_SUCCESSFUL',
    UPLOAD_FEW_SHOT_DOCUMENTS_FAILED = 'UPLOAD_FEW_SHOT_DOCUMENTS_FAILED',
    SET_INITIAL_FEW_SHOT_DOCUMENTS = 'SET_INITIAL_FEW_SHOT_DOCUMENTS',
    UPDATE_FEW_SHOT_DOCUMENT_DETAILS = 'UPDATE_FEW_SHOT_DOCUMENT_DETAILS',
    OPEN_FEW_SHOT_DOCUMENT_AND_QUERIES = 'OPEN_FEW_SHOT_DOCUMENT_AND_QUERIES',
    OPEN_FEW_SHOT_DOCUMENT_STARTED = 'OPEN_FEW_SHOT_DOCUMENT_STARTED',
    OPEN_FEW_SHOT_DOCUMENT_SUCCESSFUL = 'OPEN_FEW_SHOT_DOCUMENT_SUCCESSFUL',
    OPEN_FEW_SHOT_DOCUMENT_FAILED = 'OPEN_FEW_SHOT_DOCUMENT_FAILED',
    TOGGLE_FEW_SHOT_DOCUMENT_ANALYSIS_VIEW = 'TOGGLE_FEW_SHOT_DOCUMENT_ANALYSIS_VIEW',
    RESET_FEW_SHOT_DOCUMENT = 'RESET_FEW_SHOT_DOCUMENT',
    SET_FEW_SHOT_DOCUMENT_SELECTED_PAGE = 'SET_FEW_SHOT_DOCUMENT_SELECTED_PAGE',
    SET_FEW_SHOT_DOCUMENT_AI_ANSWER_HIGHLIGHT_INDEXES = 'SET_FEW_SHOT_DOCUMENT_AI_ANSWER_HIGHLIGHT_INDEXES',
    SET_FEW_SHOT_DOCUMENT_ANSWER = 'SET_FEW_SHOT_DOCUMENT_ANSWER',
    UPDATE_FEW_SHOT_ANSWERS_STARTED = 'UPDATE_FEW_SHOT_ANSWERS_STARTED',
    UPDATE_FEW_SHOT_ANSWERS_SUCCESSFUL = 'UPDATE_FEW_SHOT_ANSWERS_SUCCESSFUL',
    UPDATE_FEW_SHOT_ANSWERS_FAILED = 'UPDATE_FEW_SHOT_ANSWERS_FAILED',
    TOGGLE_FEW_SHOT_DOCUMENT_DELETE_MODAL = 'TOGGLE_FEW_SHOT_DOCUMENT_DELETE_MODAL',
    DELETE_FEW_SHOT_DOCUMENT_STARTED = 'DELETE_FEW_SHOT_DOCUMENT_STARTED',
    DELETE_FEW_SHOT_DOCUMENT_SUCCESSFUL = 'DELETE_FEW_SHOT_DOCUMENT_SUCCESSFUL',
    DELETE_FEW_SHOT_DOCUMENT_FAILED = 'DELETE_FEW_SHOT_DOCUMENT_FAILED',
    UPDATE_FEW_SHOT_DOCUMENTS_PRIORITY_ORDER = 'UPDATE_FEW_SHOT_DOCUMENTS_PRIORITY_ORDER',
    TOGGLE_FEW_SHOT_PRIORITY_MODAL_OPEN = 'TOGGLE_FEW_SHOT_PRIORITY_MODAL_OPEN',
    UPDATE_FEW_SHOT_PRIORITY_ORDER_STARTED = 'UPDATE_FEW_SHOT_PRIORITY_ORDER_STARTED',
    UPDATE_FEW_SHOT_PRIORITY_ORDER_SUCCESSFUL = 'UPDATE_FEW_SHOT_PRIORITY_ORDER_SUCCESSFUL',
    UPDATE_FEW_SHOT_PRIORITY_ORDER_FAILED = 'UPDATE_FEW_SHOT_PRIORITY_ORDER_FAILED'
}

export interface FewShotDocumentQuery {
    question: string;
    key: string;
    systemId: string;
    version: number;
    order: number;
    guidanceNotes: string;
    fieldType: SingleDatasetFieldType | null;
    dropdownListId: number | null;
    isMultiSelect: boolean;
    defaultAnswer: FieldValue | null;
    multiRowQuery: boolean;
    isEdgeCase: boolean;
    partyRowExists: boolean;
}

export interface FewShotDocumentUploadInfo {
    documentDescription: string;
    documentNameId: number | null;
    clientId: number | null;
    isSystem: boolean;
    scheduleStartPage: number | null;
    scheduleEndPage: number | null;
}

export interface MLFewShotDocument {
    mlFewShotDocumentId: number;
    location: string;
    documentDescription: string;
    documentNameId: number;
    documentName: string;
    agreementTypeId: number;
    agreementType: string;
    isSystem: number;
    mimeType: string;
    scheduleStartPage: number | null;
    scheduleEndPage: number | null;
    fewShotAnswers: MLData | null;
    version: number;
    percentageProgress: number;
    priority: number;
    isConfirmed: number;
    clientId: number;
    createdBy: number;
    createdDate: string;
    isArchived: number;
}

export interface FewShotDocumentTable {
    mlFewShotDocumentId: number;
    location: string;
    documentDescription: string;
    documentNameId: number;
    isSystem: number;
    mimeType: string;
    version: number;
    percentageProgress: number;
    priority: number;
    isConfirmed: number;
    clientId: number;
    createdBy: number;
    createdDate: string;
    documentName: string;
}

export interface FewShotDocumentColumnSort {
    field: keyof FewShotDocumentTable;
    order: SortOrder;
}

export interface FewShotPriorityOrder {
    mlFewShotDocumentId: number;
    documentDescription: string;
    priority: number;
    isConfirmed: number;
}

export interface DocumentNameFewShotPriorityOrder {
    [documentNameId: string]: FewShotPriorityOrder[];
}

export interface FewShotDocumentsState {
    selectedAgreementTypeId: number | null;
    isFetchingDocuments: boolean;
    documents: FewShotDocumentTable[];
    documentsTotal: number;
    tableFilters: TableFilters;
    tablePageNumber: number;
    tableColumnSort: ColumnSort | undefined;
    tablePageSize: number;
    uploadModalOpen: boolean;
    isUploading: boolean;
    filesToUpload: File[] | null;
    fileInformation: FewShotDocumentUploadInfo[];
    isOpening: boolean;
    documentUrl: null | string;
    document: MLFewShotDocument | null;
    savedDocument: MLFewShotDocument | null;
    queries: FewShotDocumentQuery[];
    analysisView: AnalysisView;
    selectedPage: number | null;
    isUpdatingFewShotAnswers: boolean;
    documentToDelete: FewShotDocumentTable | null;
    isDeleting: boolean;
    currentPriorityOrder: DocumentNameFewShotPriorityOrder;
    savedPriorityOrder: DocumentNameFewShotPriorityOrder;
    priorityModalOpen: boolean;
    isUpdatingPriority: boolean;
}
